import {
    createStyles,
    Theme,
} from "@material-ui/core";

export const styles = ({spacing, palette, transitions, typography}: Theme) => createStyles({
    card: {
        backgroundColor: palette.primary.light,
    },
    header: {
        backgroundColor: palette.primary.main,
        "& span": {
            color: palette.primary.contrastText,
            fontSize: typography.subheading.fontSize,
            fontWeight: 400,
            textTransform: "uppercase"
        }
    },
    expand: {
        display: "flex",
        marginLeft: "auto",
        textTransform: "lowercase",
        "& svg": {
            transform: "rotate(0deg)",
            transition: transitions.create("transform", {
                duration: transitions.duration.shortest
            })
        }
    },
    expandOpen: {
        "& svg": {
            transform: "rotate(180deg)"
        }
    }

});


// WEBPACK FOOTER //
// ./src/components/Tools/Tools.style.tsx